export enum EStatus {
  ACTIVE = "A",
  IN_ACTIVE = "I",
}
